import { restClient } from '@/Core'

import { LETTER_REST_URL } from '../Contracts/ILetter'

import type { ILetter } from '../Contracts/ILetter'
import type { LetterPatchBody } from '../Helpers/letterPayload'

/** Результат «Відправити»: лист після запиту й чи пішов він одразу. */
export interface SendLetterResult {
    letter: ILetter | null
    scheduled: boolean
}

/**
 * «Відправити» (`SPEC-013` §7.2, §9.4): спершу зберегти правки листа, потім
 * відправити чи відкласти.
 *
 *  1. `PATCH /services/letters/{uuid}` — тема, три переліки адрес, тіло,
 *     нові вкладення (`fileUuids`);
 *  2. `POST /services/letters/{uuid}/send` — `{scheduledAt}` для відкладеної
 *     відправки або `{}` для негайної.
 *
 * Перевірки (адресати, тема, пароль додатку автора) бек робить сам під
 * блокуванням рядка; помилка будь-якого кроку летить нагору — її показує
 * шухляда (`serverMessage`), і лист лишається відкритим (Л-19).
 */
export const SendLetterTask = async (
    uuid: string,
    body: LetterPatchBody,
    scheduledAt: string | null
): Promise<SendLetterResult> => {
    const url = `${LETTER_REST_URL}/${encodeURIComponent(uuid)}`

    await restClient.patch(url, { json: body })

    const response = (await restClient.post(`${url}/send`, {
        json: scheduledAt !== null ? { scheduledAt } : {},
    })) as unknown

    return {
        letter: response !== null && typeof response === 'object' ? (response as ILetter) : null,
        scheduled: scheduledAt !== null,
    }
}
